export default __webpack_public_path__ + "static/media/mikado5.28142d17.jpg";